<script>
    import {pop} from 'svelte-spa-router'
    import Select from 'svelte-select'
    import Switch from '../utils/switch.svelte'
    import {fade} from 'svelte/transition'

    import {getRef, getSensorInformation, getSensors, getWatch, updateAlertWatch} from "../firestore";
    import {get_sensor_id} from "../gqlQueries";
    import {of} from "rxjs"
    import {catchError, mergeMap, tap} from "rxjs/operators";

    import SiloSummary from '../silo_details/silo_summary.svelte'
    import SiloLevel from "../silo_details/silo_level.svelte"

    let watch = undefined;
    let modifiedWatch = {active: true, danger: true, warning: true};

    export let params = {};
    let id = params.id;

    let state = "NEW";

    if (id !== undefined) {
        getWatch(id).subscribe(data => {
            modifiedWatch = {...data};
            getRef(data.sensor_ref).subscribe(sensor => {
                selectedSilo = {value: sensor.id, label: sensor.name};
                state = "EDIT";
            });
        });
    }

    function cancel() {
        pop();
    }

    function save() {
        if(!modifiedWatch.sensor_ref) return;
        updateAlertWatch(id, modifiedWatch);
        pop();
    }

    function remove(){
        firebase.firestore().collection("alert_watch").doc(id).delete();
        pop();
    }

    let selectedSilo = undefined;
    let selectedSiloWithInfos = undefined;

    let sensorsItems = [];

    getSensors().subscribe(sensor => {
        sensorsItems = [...sensorsItems, {value: sensor.id, label: sensor.name}];
    });

    $: watchSelected(selectedSilo);

    function watchSelected(selected) {
        if (selected === undefined) return;

        modifiedWatch.sensor_ref = firebase.firestore().collection("sensors").doc(selected.value);

        let tempEquipment;

        get_sensor_id({id: selected.value, messages: false}).pipe(
                tap(data => tempEquipment = data),
                mergeMap(data => getSensorInformation({id: data.id, client: ""}).pipe(
                        catchError(() => of(DEFAULT_SENSOR_INFOS))
                ))
        ).subscribe(data => {
            tempEquipment.infos = data;
            selectedSiloWithInfos = tempEquipment;
        });
    }
</script>

<div class="container-fluid" transition:fade="{{duration: 200}}">
    <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
            <h3 class="text-themecolor">Equipment Summary</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#/alerts/">My Alerts</a></li>
                {#if state === "NEW"}
                    <li class="breadcrumb-item">New alert</li>
                {:else}
                    <li class="breadcrumb-item">{id}</li>
                {/if}
            </ol>
        </div>
    </div>

    <section>
        <div class="card-group separate">
            <div class="card">
                <div class="card-body">
                    <div class="card-head">
                        <h2 class="card-title">New alert watch</h2>
                    </div>

                    <div class="padding-top" checked={true}>
                        <h5>Active</h5>
                        <Switch bind:checked={modifiedWatch.active}/>

                        <h5 class="padding-top">Sensor</h5>
                        <Select items={sensorsItems} bind:selectedValue={selectedSilo}/>

                        <h5 class="padding-top">DANGER alerts</h5>
                        <Switch bind:checked={modifiedWatch.danger}/>

                        <h5 class="padding-top">WARNING alerts</h5>
                        <Switch bind:checked={modifiedWatch.warning}/>
                    </div>
                </div>


            </div>
            {#if selectedSiloWithInfos !== undefined}
                <SiloSummary silo={selectedSiloWithInfos}/>
                <SiloLevel silo={selectedSiloWithInfos}/>
            {/if}
        </div>
    </section>

    <button on:click={save} class="btn btn-primary">Save</button>
    <button on:click={cancel} class="btn btn-outline-danger">Cancel</button>
    {#if state === "EDIT"}
        <button on:click={remove} class="btn btn-danger">Delete</button>
    {/if}
</div>